/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const NONE = 'NONE';
export const ITALIC = 'CUSTOM-ITALIC';
export const NORMAL = 'CUSTOM-NORMAL';
export const UNDERLINE = 'CUSTOM-UNDERLINE';
export const WEIGHT = 'CUSTOM-WEIGHT';
export const COLOR = 'CUSTOM-COLOR';
export const COLOR_GRADIENT = 'CUSTOM-GRADIENT';
export const LETTERSPACING = 'CUSTOM-LETTERSPACING';
export const UPPERCASE = 'CUSTOM-UPPERCASE';
// Keep these prefixes disjoint. Prefix matching is startsWith-based.
export const FONT_REFERENCE = 'CUSTOM-FONTREF';
export const FONT_SIZE = 'CUSTOM-FONTSIZE';
export const LINE_HEIGHT = 'CUSTOM-LINEHEIGHT';

export const COLOR_ID = 'CUSTOM-SAVEDCOLOR'; // Note: this cannot start with 'CUSTOM-COLOR'
